// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var productRouter = {
  path: '/product',
  component: Layout,
  redirect: '/product/list',
  name: 'Product',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/product/index');
    },
    name: 'ProductList',
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return import('@/views/product/cdkey/index');
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return import('@/views/product/cdkey/creatCdkey');
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/product/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return import('@/views/product/category/index');
    },
    name: 'ProductClassify',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return import('@/views/product/attr/index');
    },
    name: 'ProductAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return import('@/views/product/comment/index');
    },
    name: 'ProductComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是),productType:商品类型,isEdit:是编辑还是复制商品
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType/:editOrCopy?',
    component: function component() {
      return import('@/views/product/creatProduct/index');
    },
    name: 'creatProduct',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/product/list"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return import('@/views/product/guarantee/index');
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return import('@/views/product/label/index');
    },
    name: 'ProductLabel',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }, {
    path: 'reservation',
    component: function component() {
      return import('@/views/product/reservation/index');
    },
    name: 'Reservation',
    meta: {
      title: '预约设置',
      icon: ''
    },
    children: [{
      path: 'toDoorService',
      component: function component() {
        return import('@/views/product/reservation/ToDoorService/index');
      },
      name: 'ToDoorService1',
      meta: {
        title: '上门服务',
        icon: ''
      }
    }, {
      path: 'inStoreService',
      component: function component() {
        return import('@/views/product/reservation/inStoreService/index');
      },
      name: 'InStoreService',
      meta: {
        title: '到店服务',
        icon: ''
      }
    }]
  }, {
    path: 'unit',
    component: function component() {
      return import('@/views/product/unit/index');
    },
    name: 'ProductUnit',
    meta: {
      title: '商品单位',
      icon: ''
    }
  }]
};
export default productRouter;